import OadpEntityButtonReadFast from './oadp-entity-button-read-fast';
export default OadpEntityButtonReadFast;
